// components/promos/PromoShowcase.jsx
import React from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled, { css } from "styled-components";
import Typography from "@mui/material/Typography";

/* ========= 数据：三个大类，每类 3 个 ========= */
const CATALOG = {
    "New Light Salad": [
        {
            title: "Amalfi Green",
            calories: 530,
            protein: "16 g",
            carbs: "36 g",
            fat: "40 g",
            desc:
                "Spinach and vital greens mix, avocado, roasted walnuts, diced cucumber, red cabbage, green and red bell peppers, spiced chickpeas, beetroot, feta + Signature lemon and herb tahini, lemon infused ev olive oil",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/291777581406_.pic_hd.jpg?x-oss-process=image/resize,m_fill,w_1200,h_1200",
            href: "/shop/pure-salad/amalfi-green",
            isNew: true,
        },
        {
            title: "Andalusian Roast",
            calories: 450,
            protein: "11 g",
            carbs: "61 g",
            fat: "22 g",
            desc:
                "Ultimate kale greens mix, roasted sweet potatoes, green and red bell peppers, red cabbage, spiced chickpeas, spiced corn, beetroot + Smoked aubergine with garlic, sicilian orange and rosemary vinaigrette, lemon infused ev olive oil",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/301777581407_.pic_hd.jpg?x-oss-process=image/resize,m_fill,w_1200,h_1200",
            href: "/shop/pure-salad/andalusian-roast",
            isNew: true,
        },
        {
            title: "Santorini Garden",
            calories: 480,
            protein: "12 g",
            carbs: "35 g",
            fat: "34 g",
            desc:
                "Spinach and vital greens, roasted walnuts, tomato and red onion, diced cucumber, spiced chickpeas, kalamata olives, red cabbage, green and red bell peppers + Signature hummus, pomegranate vinaigrette, lemon infused ev olive oil",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/311777581409_.pic_hd.jpg?x-oss-process=image/resize,m_fill,w_1200,h_1200",
            href: "/shop/pure-salad/santorini-garden",
            isNew: true,
        },
    ],

    Bowls: [
        {
            title: "Aegean Power Bowl",
            price: "£12.25",
            calories: 740,
            weight: "540 g",
            protein: "45 g",
            carbs: "55 g",
            fat: "30 g",
            fibre: "7.5 g",
            desc:
                "Herb grilled chicken, kleftiko lamb + Boiled egg, saffron rice, ultimate kale greens mix, red cabbage, tomato and red onion, kalamata olives, spiced chickpeas, green and red bell peppers + Pomegranate vinaigrette, tzatziki",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/bowl%20pictures_square/Grain_-green_goddess_0005_Grain_aegean_power.jpg",
            href: "/shop/bowls/aegean-power",
        },
        {
            title: "Vitality Bowl",
            price: "£13.25",
            calories: 725,
            weight: "530 g",
            protein: "42 g",
            carbs: "55 g",
            fat: "30 g",
            fibre: "8–9 g",
            desc:
                "Oregano salmon + Avocado, tri-quinoa, spinach and vital greens mix, seasoned broccoli, beetroot, kalamata olives, tomato and cucumber, red cabbage, spiced chickpeas + Sicilian orange & rosemary vinaigrette, smoked aubergine with garlic",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/bowl%20pictures_square/Grain_-green_goddess_0000_Grain_Vitality.jpg",
            href: "/shop/bowls/vitality",
        },
        {
            title: "Keto Spartan",
            price: "£12.25",
            calories: 495,
            weight: "495 g",
            protein: "42 g",
            carbs: "26 g",
            fat: "26 g",
            fibre: "4–5 g",
            desc:
                "Herb grilled chicken + Avocado, ultimate kale greens mix, kalamata olives, diced cucumber, red cabbage, spiced chickpeas, tomato and cucumber + Signature lemon & herb tahini, tzatziki",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/bowl%20pictures_square/Grain_-green_goddess_0004_Grain_keto_.jpg",
            href: "/shop/bowls/keto-spartan",
        },
        {
            title: "The Green Goddess",
            price: "£10.50",
            calories: 480,
            weight: "475 g",
            protein: "21 g",
            carbs: "44 g",
            fat: "23 g",
            fibre: "8–9 g",
            diet: "VG",
            desc:
                "Green falafel + Spinach and vital greens mix, diced cucumber, beetroot, spiced corn, tomato and red onion, pickled jalapeños + Zhoug, signature hummus",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/bowl%20pictures_square/Grain_-green_goddess_0006_.jpg",
            href: "/shop/bowls/green-goddess",
        },
        {
            title: "Saffron Soul",
            price: "£11.95",
            calories: 630,
            weight: "485 g",
            protein: "33 g",
            carbs: "48 g",
            fat: "28 g",
            fibre: "6–7 g",
            diet: "V",
            desc:
                "Halloumi + Avocado, tri-quinoa, spinach and vital greens mix, red cabbage, beetroot, diced cucumber, spiced corn, tomato and cucumber + Pomegranate vinaigrette, smoked aubergine with garlic",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/bowl%20pictures_square/Grain_-green_goddess_0001_Grain_saffron_soul.jpg",
            href: "/shop/bowls/saffron-soul",
        },
        {
            title: "Lentil Legacy",
            price: "£11.25",
            calories: 610,
            weight: "510 g",
            protein: "44 g",
            carbs: "48 g",
            fat: "24 g",
            fibre: "9–10 g",
            desc:
                "Herb chicken meatballs + Grain lentils, tomato and red onion, spiced chickpeas, green and red bell peppers, beetroot, red cabbage, maple walnuts + Sicilian orange & rosemary vinaigrette, rich whipped feta",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/bowl%20pictures_square/Grain_-green_goddess_0003_Grain_lentil_legacy.jpg",
            href: "/shop/bowls/lentil-legacy",
        },
        {
            title: "The Olympian",
            price: "£12.25",
            calories: 700,
            weight: "515 g",
            protein: "48 g",
            carbs: "52 g",
            fat: "28 g",
            fibre: "7 g",
            desc:
                "Spicy beef meatballs + Boiled egg, tri-quinoa, ultimate kale greens mix, diced cucumber, spiced corn, green and red bell peppers, kalamata olives, tomato and red onion + Creamy garlic labneh, hot harissa",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/bowl%20pictures_square/Grain_-green_goddess_0002_Grain_Olympian_%E5%89%AF%E6%9C%AC.jpg",
            href: "/shop/bowls/the-olympian",
        },
        {
            title: "Greens +\nGrain Bowl",
            price: "£13.25",
            calories: 725,
            weight: "530 g",
            protein: "42 g",
            carbs: "55 g",
            fat: "30 g",
            fibre: "8–9 g",
            desc:
                "Mix and match your favourite greens and grains to build a bowl just the way you like it",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/bowl%20pictures_square/Grain_saffron_rice_0001_Grain_grains_and_greens.jpg",
            href: "/shop/bowls/vitality",
            highlight: true,
        },
        {
            title: "Grain Bowl",
            price: "£13.25",
            calories: "358-1498",
            weight: "530 g",
            protein: "42 g",
            carbs: "55 g",
            fat: "30 g",
            fibre: "8–9 g",
            desc:
                "Choose your base of saffron rice, tri quinoa, or grain lentils for a hearty start.",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/bowl%20pictures_square/Grain_saffron_rice_0002_.jpg",
            href: "/shop/bowls/vitality",
            highlight: true,
        },
        {
            title: "Greens Bowl",
            price: "£13.25",
            calories: "430-1580",
            weight: "530 g",
            protein: "42 g",
            carbs: "55 g",
            fat: "30 g",
            fibre: "8–9 g",
            desc:
                "Choose your base of spinach & vital greens mix or ultimate kale greens mix for a fresh start.",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/bowl%20pictures_square/Grain_saffron_rice_0000_Grain_greens.jpg",
            href: "/shop/bowls/vitality",
            highlight: true,
        },
    ],

    Pitas: [
        {
            title: "Zeus’ Feast",
            price: "£10.95",
            calories: "220-1380",
            weight: "260 g",
            protein: "32 g",
            carbs: "60 g",
            fat: "26 g",
            fibre: "6.5 g",
            desc:
                "Herb grilled chicken + Tomato and cucumber, kalamata olives, red cabbage, pickled jalapeños + Yogurt dill, smokey red pepper hummus",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Pita_square/apollo__0000_zeus.jpg",
            href: "/shop/pitas/zeus-feast",
        },
        {
            title: "Spartan Strength",
            price: "£11.50",
            calories: 750,
            weight: "260 g",
            protein: "35 g",
            carbs: "62 g",
            fat: "26 g",
            fibre: "7.2 g",
            desc:
                "Kleftiko lamb + Tomato and cucumber, red cabbage, spiced chickpeas, seasoned broccoli + Tzatziki, hot harissa",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Pita_square/apollo__0001_spartan.jpg",
            href: "/shop/pitas/spartan-strength",
        },
        {
            title: "Apollo’s Garden",
            price: "£10.50",
            calories: 650,
            weight: "255 g",
            protein: "22 g",
            carbs: "74 g",
            fat: "26 g",
            fibre: "8.5 g",
            diet: "VG",
            desc:
                "Green falafel + Beetroot, red cabbage, tomato and cucumber, spiced corn + Zhoug, signature hummus",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Pita_square/apollo__0006_apollo.jpg",
            href: "/shop/pitas/apollos-garden",
        },
        {
            title: "Olympian Duo",
            price: "£11.25",
            calories: 800,
            weight: "270 g",
            protein: "38 g",
            carbs: "66 g",
            fat: "32 g",
            fibre: "7 g",
            desc:
                "Herb grilled chicken, kleftiko lamb + Red cabbage, tomato and cucumber, pickled jalapeños, seasoned broccoli + Tzatziki, hot harissa",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Pita_square/apollo__0004_olympian.jpg",
            href: "/shop/pitas/olympian-duo",
        },
        {
            title: "Athenian Flame",
            price: "£11.50",
            calories: 720,
            weight: "260 g",
            protein: "36 g",
            carbs: "60 g",
            fat: "30 g",
            fibre: "6.8 g",
            desc:
                "Spicy beef meatballs + Red onion, red and green peppers, tomato and red onion, pickled jalapeños + Creamy garlic labneh, muhammara",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Pita_square/apollo__0005_athenian.jpg",
            href: "/shop/pitas/athenian-flame",
        },
        {
            title: "Athena’s Balance",
            calories: 690,
            protein: "28 g",
            carbs: "69 g",
            fat: "33 g",
            diet: "V",
            desc: "Grilled halloumi + Spinach and vital greens mix, tomato and red onion, diced cucumber + Signature lemon and herb tahini, smoked aubergine with garlic",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/64016603aff20d93c09b4c8fc6b4f5ed.pic?x-oss-process=image/resize,m_fill,w_1200,h_1200",
            href: "/shop/pitas/athenas-balance",
        },
    ],

    "Breakfast": [
        {
            title: "The Double Cured",
            price: "£8.50",
            calories: 445,
            weight: "185 g",
            protein: "24 g",
            carbs: "35 g",
            fat: "21 g",
            fibre: "2 g",
            desc: "Tender salt beef, smoked salmon + Cream cheese + Lemon infused EV olive oil",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Breakfast_square/beef_salmon_colour.jpg",
            href: "/shop/breakfast/bagels-double-cured",
        },
        {
            title: "The Deli Salt Beef",
            price: "£7.50",
            calories: 390,
            weight: "190 g",
            protein: "20 g",
            carbs: "34 g",
            fat: "17 g",
            fibre: "2 g",
            desc: "Tender salt beef + Pickle + Labneh cream",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/21b35d2ea362f90779866aece99d3ea2.pic?x-oss-process=image/resize,m_fill,w_1200,h_1200",
            href: "/shop/breakfast/bagels-deli-salt-beef",
        },
        {
            title: "Aegean Smoked Salmon",
            price: "£6.50",
            calories: 325,
            weight: "135 g",
            protein: "15 g",
            carbs: "35 g",
            fat: "12 g",
            fibre: "2 g",
            desc: "Smoked salmon + Cream cheese + Lemon infused EV olive oil",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Breakfast_square/Grain_salmon_ccheese.png?x-oss-process=image/resize,m_fill,w_1200,h_1200",
            href: "/shop/breakfast/bagels-smoked-salmon",
        },
        {
            title: "Avocado Sunrise",
            price: "£5.50",
            calories: 440,
            weight: "205 g",
            protein: "16 g",
            carbs: "36 g",
            fat: "25 g",
            fibre: "4 g",
            diet: "V",
            desc: "Fresh smashed avocado, poached egg + Cream cheese + Lemon infused EV olive oil",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Breakfast_square/egg_avo.jpg",

            href: "/shop/breakfast/bagels-avocado-sunrise",
        },
        {
            title: "The Levantine Stack",
            price: "£5.50",
            calories: 530,
            weight: "265 g",
            protein: "20 g",
            carbs: "40 g",
            fat: "30 g",
            fibre: "6 g",
            diet: "V",
            desc: "Grilled halloumi, fresh smashed avocado + Tomato + Zhoug, signature hummus, lemon infused EV olive oil",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Breakfast_square/halloumi.jpg",
            href: "/shop/breakfast/bagels-levantine-stack",
        },
        {
            title: "The Morning Mezze",
            price: "£5.50",
            calories: 480,
            weight: "265 g",
            protein: "13 g",
            carbs: "56 g",
            fat: "28 g",
            fibre: "6 g",
            diet: "V",
            desc: "Egg + Mayonnaise",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/fcb977bd587497d1cb1f25c95b489b76.pic?x-oss-process=image/resize,m_fill,w_1200,h_1200",
            href: "/shop/breakfast/bagels-levantine-stack",
        },
        {
            title: "The Mediterranean Riviera",
            price: "£5.50",
            calories: 510,
            weight: "265 g",
            protein: "21 g",
            carbs: "54 g",
            fat: "30 g",
            fibre: "6 g",
            desc: "Tuna + Sweetcorn + Mayonnaise ",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/8bd18a29563e58ffe05224733d65d1c3.pic?x-oss-process=image/resize,m_fill,w_1200,h_1200",
            href: "/shop/breakfast/bagels-levantine-stack",
        },
        {
            title: "The Coronation Levant",
            price: "£5.50",
            calories: 445,
            weight: "265 g",
            protein: "17 g",
            carbs: "66 g",
            fat: "17 g",
            fibre: "6 g",
            desc: "Coronation style chicken + Mayonnaise",
            image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/b91b7b2532eae1b920e0a7ba280db6b4.pic?x-oss-process=image/resize,m_fill,w_1200,h_1200",
            href: "/shop/breakfast/bagels-levantine-stack",
        },
        // {
        //     title: "Pesto and Cream Medley",
        //     price: "£4.75",
        //     calories: 410,
        //     weight: "165 g",
        //     protein: "13 g",
        //     carbs: "36 g",
        //     fat: "20 g",
        //     fibre: "2 g",
        //     diet: "V",
        //     desc: "Creamy cream cheese + Kale pesto",
        //     image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Breakfast_square/pesto.jpg",
        //     href: "/shop/breakfast/bagels-pesto-cream",
        // },
        // {
        //     title: "Aegean Avocado Smash",
        //     price: "£5.95",
        //     calories: 360,
        //     weight: "201 g",
        //     protein: "8 g",
        //     carbs: "36 g",
        //     fat: "19 g",
        //     fibre: "6.5 g",
        //     diet: "VG",
        //     desc: "Fresh smashed avocado + Signature lemon & herb tahini",
        //     image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Breakfast_square/toast_avo.jpg",
        //     href: "/shop/breakfast/toast-aegean-avo-smash",
        // },
        // {
        //     title: "Santorini Egg and Avocado",
        //     price: "£5.95",
        //     calories: 370,
        //     weight: "173 g",
        //     protein: "13 g",
        //     carbs: "32 g",
        //     fat: "20 g",
        //     fibre: "5.5 g",
        //     diet: "V",
        //     desc: "Fresh smashed avocado, poached egg + Signature lemon & herb tahini",
        //     image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Breakfast_square/toast_avo_egg.jpg",
        //     href: "/shop/breakfast/toast-santorini-egg-avo",
        // },
        // {
        //     title: "Santorini Salmon and Egg",
        //     price: "£6.50",
        //     calories: 400,
        //     weight: "205 g",
        //     protein: "11 g",
        //     carbs: "34 g",
        //     fat: "22 g",
        //     fibre: "4.5 g",
        //     desc: "Fresh smashed avocado, smoked salmon + Yogurt dill",
        //     image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Breakfast_square/toast_salmon.jpg",
        //     href: "/shop/breakfast/toast-santorini-salmon-egg",
        // },
        // {
        //     title: "Ionian Feta and Tomato",
        //     price: "£5.95",
        //     calories: 410,
        //     weight: "203 g",
        //     protein: "20 g",
        //     carbs: "29 g",
        //     fat: "22 g",
        //     fibre: "4 g",
        //     diet: "V",
        //     desc: "Whipped feta + Tomato + Muhammara",
        //     image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Breakfast_square/toast_feta_tomato.jpg",
        //     href: "/shop/breakfast/toast-ionian-feta-tomato",
        // },
    ],
    Matcha: [
        { title: "Pistachio Cream Matcha", desc: "Uji Ceremonial Matcha", image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Drinks_square/White-Chocolate-Matcha_0020_Pistachio-Cream-Matcha.jpg", href: "/shop/matcha/pistachio-cream" },
        // { title: "Signature Pure Matcha", desc: "Uji Ceremonial Matcha", image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Drinks_square/White-Chocolate-Matcha_0009_Signature-Pure-Matcha.jpg", href: "/shop/matcha/signature-pure" },
        { title: "Original Matcha Latte", desc: "Uji Ceremonial Matcha", image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Drinks_square/White-Chocolate-Matcha_0011_Matcha%20Latte%20Hot.jpg", href: "/shop/matcha/original-latte" },
        { title: "Dirty Matcha", desc: "Uji Ceremonial Matcha", image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Drinks_square/White-Chocolate-Matcha_0017_Dirty-Matcha-Hot.jpg", href: "/shop/matcha/dirty" },
        // { title: "Matcha Sparkling", desc: "Uji Ceremonial Matcha", image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Drinks_square/White-Chocolate-Matcha_0021_Matcha-Sparkling.jpg", href: "/shop/matcha/sparkling" },
        { title: "Matcha Coconut", desc: "Uji Ceremonial Matcha", image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Drinks_square/White-Chocolate-Matcha_0023_Matcha-Coconut.jpg", href: "/shop/matcha/coconut" },
        { title: "Strawberry Matcha", desc: "Uji Ceremonial Matcha", image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Drinks_square/White-Chocolate-Matcha_0019_Strawberry-Matcha.jpg", href: "/shop/matcha/strawberry" },
        { title: "Blueberry Matcha", desc: "Uji Ceremonial Matcha", image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Drinks_square/White-Chocolate-Matcha_0025_Blueberry-Matcha.jpg", href: "/shop/matcha/blueberry" },
        { title: "Matcha Mango Kefir", desc: "Uji Ceremonial Matcha", image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Drinks_square/White-Chocolate-Matcha_0022_Matcha-Mango-Kefir.jpg", href: "/shop/matcha/mango-kefir" },
    ],

    "Coffee & More": [
        { title: "Americano", desc: "Organic coffee", image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Drinks_square/White-Chocolate-Matcha_0008_Americano-Hot-Yellow.jpg", href: "/shop/drinks/americano" },
        { title: "Latte", desc: "Organic coffee", image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Drinks_square/White-Chocolate-Matcha_0003_Latte%20Hot.jpg", href: "/shop/drinks/latte" },
        { title: "Flat White", desc: "Organic coffee", image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Drinks_square/White-Chocolate-Matcha_0004_Flat%20White%20Hot.jpg", href: "/shop/drinks/flat-white" },
        { title: "Cappuccino", desc: "Organic coffee", image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Drinks_square/White-Chocolate-Matcha_0007_Cappuccino%20Hot.jpg", href: "/shop/drinks/cappuccino" },
        { title: "Espresso", desc: "Organic coffee", image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Drinks_square/White-Chocolate-Matcha_0005_Espresso.jpg", href: "/shop/drinks/espresso" },
        { title: "Macchiato", desc: "Organic coffee", image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Drinks_square/White-Chocolate-Matcha_0001_Macchiato%20Hot.jpg", href: "/shop/drinks/macchiato" },
        { title: "Hot Chocolate", desc: "", image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Drinks_square/White-Chocolate-Matcha_0013_Hot%20Chocolate.jpg", href: "/shop/drinks/hot-chocolate" },
        { title: "English Breakfast Tea", desc: "Premium tea", image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Drinks_square/White-Chocolate-Matcha_0015_English-Breakfast-Tea.jpg", href: "/shop/drinks/english-breakfast" },
        { title: "Jasmine Green Tea", desc: "Premium tea", image: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Drinks_square/White-Chocolate-Matcha_0012_Jasmine-Green-Tea.jpg", href: "/shop/drinks/jasmine-green" },
    ],

};


/* === 外层区块（保留你的样式） === */
const Section = styled.section`${tw`w-full text-dark-500 py-8`}`;

const PageTitle = styled.h1`
    ${tw`px-2 sm:px-10 mb-6 text-center`}
    font-family: "Roboto Condensed", sans-serif;
    font-weight: 400;
    font-size: clamp(2.8rem, 2.1rem + 1.8vw, 4.2rem);
    line-height: 1;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    padding-top: clamp(2.5rem, 1.8rem + 1.6vw, 3.5rem);
    padding-bottom: clamp(2.2rem, 1.6rem + 1.4vw, 3.2rem);
`;

/* === 卡片样式（保持） === */
const Tile = motion(styled.article`
    ${tw`relative`}
    overflow: hidden;
    border-radius: 20px;
    background: #fffbdc;
`);

const HighlightOverlay = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    color: #fffbdc;
    text-align: left;
    padding: clamp(1.2rem, 0.9rem + 1.2vw, 2.4rem);
    z-index: 2;
    gap: clamp(0.75rem, 0.6rem + 0.8vw, 1.4rem);
    height: 100%;
`;

const HighlightTitle = styled.h3`
    color: #FAB600;
    margin: 0;
    font-family: "Work Sans", sans-serif;
    font-weight: 600;
    font-size: clamp(2.16rem, 1.68rem + 1.68vw, 3.12rem);
    line-height: 1.15;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    white-space: pre-line;
`;

const HighlightButton = styled.a`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    background: #FAB600;
    color: #14133b;
    padding: 0.6rem 1.92rem;
    font-family: "Work Sans", sans-serif;
    font-size: clamp(0.95rem, 0.9rem + 0.3vw, 1.1rem);
    font-weight: 500;
    text-decoration: none;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;
    margin-top: auto;
    align-self: flex-start;

    &:active { transform: translateY(0); box-shadow: none; }
`;

const RatioBox = styled.div`
    position: relative;
    width: 100%;
    aspect-ratio: 1;
    overflow: hidden;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    @supports not (aspect-ratio: 1) { padding-top: 100%; }
`;

const TileImg = styled(motion.img)`
    position: absolute;
    inset: 0;
    width: 100%; height: 100%;
    object-fit: cover;
    display: block;
    will-change: transform;
    z-index: 0;
`;

const Details = styled.div`
    position: relative;
    z-index: 1;
    color: #14133b;
    padding: 12px 12px 16px;

    @media (min-width: 768px) { padding: 14px 16px 18px; }

    .title {
        font-family: "Roboto", system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
        font-weight: 300;
        text-transform: uppercase;
        letter-spacing: 0.4px;
        color: #14133b;
        font-size: clamp(1.25rem, 1.02rem + 1vw, 1.6rem);
        line-height: 1.2;
        white-space: pre-line;
        margin: 2px 0 6px;
    }

    .desc {
        color: #14133b;
        font-size: clamp(1rem, 0.86rem + 0.2vw, 1.4rem);
        line-height: 1.35;
        text-wrap: pretty;
        margin-top: 6px;
    }
`;

const NutritionGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px 18px;
    margin-top: 20px;
    padding-top: 16px;
`;

const NutritionItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    text-transform: uppercase;
    color: rgba(107, 114, 128, 0.63);

    &:nth-of-type(2n) {
        padding-left: clamp(12px, 1.5vw, 18px);
    }

    span.label {
        font-size: clamp(0.65rem, 0.6rem + 0.18vw, 0.8rem);
        letter-spacing: 0.02em;
        font-weight: 500;
        margin-bottom: 4px;
    }

    span.value {
        font-size: clamp(0.65rem, 0.6rem + 0.18vw, 0.8rem);
        font-weight: 400;
        letter-spacing: 0.02em;
    }
`;

const DIET_ICONS = Object.freeze({
    V: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/V_VG_GF%20icon/1.png",
    VG: "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/V_VG_GF%20icon/2.png"
});

const DIET_LABELS = Object.freeze({
    V: "Vegetarian friendly",
    VG: "Vegan friendly"
});

const DietBadge = styled.img`
    position: absolute;
    top: 16px;
    right: 16px;
    width: clamp(28px, 26px + 1vw, 36px);
    height: clamp(28px, 26px + 1vw, 36px);
    pointer-events: none;
    z-index: 3;
`;

const NEW_ITEM_ICON = "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/281777581404_.pic_hd.jpg";

const NewBadge = styled.img`
    position: absolute;
    top: 12px;
    right: 12px;
    width: clamp(56px, 48px + 3vw, 88px);
    height: auto;
    pointer-events: none;
    z-index: 3;
`;

/* 悬浮动效（禁用图片缩放） */
const hoverMotion = { whileHover: {}, transition: { type: "spring", damping: 20, stiffness: 260 } };
const imgVariants = { rest: { scale: 1 }, hover: { scale: 1 } };

/* ===== 容器 ===== */
const CategoryHeader = styled.h2`
  margin: 0;
  padding: 0 8px;
  font-family: "Roboto Condensed", sans-serif;
  font-weight: 400;
  font-size: clamp(1.8rem, 1.15rem + 1vw, 2.5rem);
  line-height: 1.2;
  @media (min-width: 768px) { padding: 0 40px; }
`;

/* 菜单网格：1/2/3 列 */
const MenuGrid = styled.div`
    ${tw`w-full text-white`}
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 12px 8px 28px;

    @media (min-width: 768px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 20px;
        padding: 16px 40px 36px;
    }
    @media (min-width: 1024px) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 24px;
        padding: 20px 40px 40px;
    }
`;

/* === FeatureGrid 跟随 MenuGrid 的列数与断点 === */
const FeatureGrid = styled(MenuGrid)`
    padding-top: 40px;
    padding-bottom: 64px;
    align-items: stretch;
    grid-auto-rows: 1fr;
    @media (min-width: 768px) { padding-top: 48px; padding-bottom: 80px; }
`;

/* === FeatureCard 响应式尺寸 ===
   自适应高度 + clamp 控制，确保缩放时内容不会被裁切，
   配合 flex 让按钮始终靠下对齐。*/
const FeatureCard = styled.div`
    ${tw`rounded-3xl w-full overflow-hidden`}
    background-color: ${({ $bg }) => $bg};
    color: ${({ $color }) => $color};
    display: flex;
    flex-direction: column;
    position: relative;
    text-align: center;
    min-height: clamp(320px, 52vw, 420px);
`;

const FeatureCardInner = styled.div`
  flex: 1 1 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  gap: clamp(1.5rem, 1.2rem + 1vw, 2rem);
  padding: clamp(2.2rem, 1.8rem + 1.8vw, 3.6rem);
  width: 100%;
`;

const FeatureButtonWrapper = styled.div`
  margin-top: auto;
  padding-top: clamp(1rem, 0.8rem + 1vw, 1.6rem);
  width: 100%;
  display: flex;
  justify-content: center;
`;

const FeatureDescription = styled.p`
    ${tw`tracking-wide`}
    font-family: "Work Sans", sans-serif;
    font-weight: 400;
    font-size: clamp(0.8rem, 0.72rem + 0.42vw, 1rem);
    line-height: 1.45;
    letter-spacing: 0.08em;
    margin: 0;
    text-transform: uppercase;
`;

const FeatureTitle = styled.h3`
    font-family: "Roboto Condensed", sans-serif;
    font-weight: 400;
    font-size: clamp(1.4rem, 1.16rem + 1.2vw, 2.35rem);
    line-height: 1.05;
    margin: 0;
`;

const FeatureButton = styled.a`
  ${tw`inline-flex items-center justify-center font-semibold`}
  padding: 0.9rem 2.4rem;
  border-radius: 999px;
  background-color: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  text-decoration: none;
  font-size: 1rem;
  letter-spacing: 0.05em;

`;

/* ===== 菜单页渲染：按“类名 + 卡片”顺序输出 ===== */
export default function PromoShowcaseMenu() {
    const ORDER = ["New Light Salad", "Bowls", "Pitas", "Breakfast", "Matcha", "Coffee & More", "Energy Truffles"];

    return (
        <Section aria-label="Menu collections">
            <PageTitle>Passionate About Taste.</PageTitle>

            {ORDER.map((cat) => {
                const items = CATALOG[cat] ?? [];
                if (!items.length) return null;

                return (
                    <section key={cat} aria-labelledby={`menu-${cat}`}>
                        <CategoryHeader id={`menu-${cat}`}>{cat}</CategoryHeader>

                        <MenuGrid>
                            {items.map((it, idx) => {
                                const dietIcon = it.diet ? DIET_ICONS[it.diet] : undefined;
                                const dietAlt = it.diet ? DIET_LABELS[it.diet] ?? `${it.diet} friendly` : undefined;
                                const isHighlighted = Boolean(it.highlight);

                                return (
                                    <Tile
                                        key={`${cat}-${idx}`}
                                        {...hoverMotion}
                                        initial="rest"
                                        animate="rest"
                                        whileHover="hover"
                                    >
                                        {dietIcon && <DietBadge src={dietIcon} alt={dietAlt} loading="lazy" />}
                                        {it.isNew && <NewBadge src={NEW_ITEM_ICON} alt="New item" loading="lazy" />}

                                        <RatioBox>
                                            <TileImg
                                                src={it.image}
                                                alt={it.title || `menu-${idx + 1}`}
                                                loading="lazy"
                                                variants={imgVariants}
                                                transition={{ type: "spring", stiffness: 220, damping: 18 }}
                                            />
                                            {isHighlighted && (
                                                <HighlightOverlay>
                                                    <HighlightTitle>{it.title}</HighlightTitle>
                                                    <HighlightButton href="https://order.grainmediterranean.com/">
                                                        Build Your Own
                                                    </HighlightButton>
                                                </HighlightOverlay>
                                            )}
                                        </RatioBox>

                                        <Details>
                                            <Typography component="h3" className="title">
                                                {it.title}
                                            </Typography>
                                            {it.desc && <p className="desc">{it.desc}</p>}

                                            {(() => {
                                                const nutrition = [
                                                    it.calories ? { label: "CALORIES", value: `${it.calories} kcal` } : null,
                                                    it.protein ? { label: "PROTEIN", value: it.protein } : null,
                                                    it.carbs ? { label: "CARBS", value: it.carbs } : null,
                                                    it.fat ? { label: "FAT", value: it.fat } : null,
                                                ].filter(Boolean);

                                                if (!nutrition.length) return null;

                                                return (
                                                    <NutritionGrid>
                                                        {nutrition.map((entry) => (
                                                            <NutritionItem key={entry.label}>
                                                                <span className="label">{entry.label}</span>
                                                                <span className="value">{entry.value}</span>
                                                            </NutritionItem>
                                                        ))}
                                                    </NutritionGrid>
                                                );
                                            })()}
                                        </Details>
                                    </Tile>
                                );
                            })}
                        </MenuGrid>
                    </section>
                );
            })}

            {/* Feature 卡片区（自适应高度，按钮统一对齐） */}
            <FeatureGrid>
                <FeatureCard $bg="#fdd96e" $color="#141241">
                    <FeatureCardInner>
                        <FeatureDescription>
                            MIX WHOLESOME GRAINS, GREENS, AND FLAVOURS THAT MAKE YOU FEEL GOOD.
                        </FeatureDescription>
                        <FeatureTitle>
                            Build your own
                            <br />
                            bowl, your way
                        </FeatureTitle>
                        <FeatureButtonWrapper>
                            <FeatureButton href="https://order.grainmediterranean.com/" $bg="#141241" $color="#fdd96e">
                                ORDER NOW
                            </FeatureButton>
                        </FeatureButtonWrapper>
                    </FeatureCardInner>
                </FeatureCard>

                <FeatureCard $bg="#dae1a2" $color="#141241">
                    <FeatureCardInner>
                        <FeatureDescription>
                            FRESHLY PREPARED FOR YOUR TEAM OR EVENT. BALANCED, FLAVOURFUL, AND SEED-OIL FREE.
                        </FeatureDescription>
                        <FeatureTitle>
                            Catering, the <br />
                            Healthy. Hearty.
                            <br />Honest. way.
                        </FeatureTitle>
                        <FeatureButtonWrapper>
                            <FeatureButton href="https://order.grainmediterranean.com/" $bg="#b2c868" $color="#141241">
                                ORDER CATERING
                            </FeatureButton>
                        </FeatureButtonWrapper>
                    </FeatureCardInner>
                </FeatureCard>

                <FeatureCard $bg="#b3cac7" $color="#141241">
                    <FeatureCardInner>
                        <FeatureDescription>
                            Transparency matters. View our full nutritional and allergen guide here.
                        </FeatureDescription>
                        <FeatureTitle>
                            Know what’s in <br /> your bowl.
                        </FeatureTitle>
                        <FeatureButtonWrapper>
                            <FeatureButton href="https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/Bowls/Grain%20Nutrition%20%26%20Allergen%20Guide%20_%20July.pdf" $bg="#f2c148" $color="#141241">
                                DOWNLOAD INFO
                            </FeatureButton>
                        </FeatureButtonWrapper>
                    </FeatureCardInner>
                </FeatureCard>
            </FeatureGrid>
        </Section>
    );
}
